import React from 'react';
import { useCookieConsent } from '../contexts/CookieConsentContext';
import CookieConsentBanner from './CookieConsentBanner';
import CookieSettingsModal from './CookieSettingsModal';

const CookieConsentManager: React.FC = () => {
  const { showSettingsModal, hideSettings } = useCookieConsent();

  return (
    <>
      <CookieConsentBanner />
      <CookieSettingsModal 
        isOpen={showSettingsModal} 
        onClose={hideSettings} 
      />
    </>
  );
};

export default CookieConsentManager;
